import { render, staticRenderFns } from "./DuplicateCandidateResolve.vue?vue&type=template&id=6aca6d23&scoped=true&"
import script from "./DuplicateCandidateResolve.vue?vue&type=script&lang=js&"
export * from "./DuplicateCandidateResolve.vue?vue&type=script&lang=js&"
import style0 from "./DuplicateCandidateResolve.vue?vue&type=style&index=0&id=6aca6d23&prod&scoped=true&lang=css&"
import style1 from "./DuplicateCandidateResolve.vue?vue&type=style&index=1&id=6aca6d23&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aca6d23",
  null
  
)

export default component.exports